<template>
  <div class="app-wrapper" style="height: auto; min-height: calc(100% - 115px);" :class="classObj">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"></div>
    <div class="sidebar-container" :style="device!=='mobile' ? 'top: 65px; ': 'top: 80px;'">
      <el-row class="rowTop">
        <h3 style="width: 100%; text-align: center; color: #000; font-size: 15px;">{{ appName }}</h3>
      </el-row>
      <sidebar></sidebar>
    </div>
    <div style="display: flex; flex-direction: column;" class="main-container">
      <navbar></navbar>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from '@/mixin/ResizeHandler'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  data() {
    return {
      appName: process.env.APP_NAME.toUpperCase()
    }
  },
  mounted() {
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('CloseSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/variables.scss";
  @import "src/styles/mixin.scss";
  .app-wrapper {
    color: #000;
    @include clearfix;
    overflow: scroll;
    position: relative;
    height: calc(100% - 115px);
    width: 100%;
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }
  .rowTop {
    height: 50px;
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/layout/Layout.vue